import { useMemo } from 'react';
import { LuContainer } from '@/components/react-icons/main';
import Tag from './Tag.jsx';
import { useSelector } from 'react-redux';
import selectors from '@/redux/selectors/selectors.js';

const EnvironmentTag = ({ id, environmentId, overrideName, size = 'sm', ...props }) => {
  const environments = useSelector(selectors.environments) || [];

  const environment = useMemo(() => environments.find((e) => e.id === environmentId), [JSON.stringify(environments), environmentId]);
  const name = overrideName || environment?.name;

  const variant = useMemo(() => {
    if (name === 'Sandbox') {
      return 'warning';
    }

    if (name === 'Production') {
      return 'accent';
    }

    return 'info';
  }, [name]);

  return (
    <Tag id={id} variant={variant} size={size} icon={LuContainer} iconVariant="" data-title={name} {...props}>
      {name}
    </Tag>
  );
};

export default EnvironmentTag;
